var _linearGradient, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 180,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 180",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "49.980476%",
    x2: "49.980476%",
    y1: ".000001%",
    y2: "100.030167%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e52d27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf171d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m101.6 123.2 69.2-35.8-69.2-36.1z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m101.6 51.3 60.7 40.5 8.5-4.4z",
    fill: "#420000",
    opacity: 0.12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m253.301054 38.8s-2.499024-17.6-10.196017-25.4c-9.696212-10.2-20.591956-10.2-25.689965-10.8-35.68606-2.6-89.365092-2.6-89.365092-2.6h-.09996s-53.6790321 0-89.5650141 2.6c-4.9980477.6-15.8937915.6-25.6899649 10.8-7.59703241 7.8-10.09605623 25.4-10.09605623 25.4s-2.59898477 20.8-2.59898477 41.5v19.4c0 20.7 2.59898477 41.4 2.59898477 41.4s2.49902382 17.6 10.19601723 25.4c9.6962124 10.2 22.4912143 9.9 28.1889886 10.9 20.4919953 2 86.9660294 2.6 86.9660294 2.6s53.778992-.1 89.565013-2.7c4.998048-.6 15.893792-.6 25.689965-10.8 7.696993-7.8 10.196017-25.4 10.196017-25.4s2.598985-20.7 2.598985-41.4v-19.4c-.099961-20.7-2.698946-41.5-2.698946-41.5zm-151.740726 84.4v-71.9l69.172979 36.1z",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.cfb766268d9589d945c78a0fe55db766.svg";
export { ForwardRef as ReactComponent };